import { Directive, OnInit, ViewChild, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatSort } from '@angular/material/sort';
import { NotificationAdminFilterKey, NotificationDto } from '@workspace/data-types';
import {
  ActionButton,
  ActionMenu,
  BaseDataTableComponent,
  DataHeaderFilter,
  DataListColumn,
} from '@workspace/ng-aura';
import { Observable } from 'rxjs';

export type NotificationColumnKey = 'context' | 'title' | 'message' | 'type' | 'read' | 'createdAt';

@Directive()
export abstract class AbstractNotificationsDataTableCoreComponent<T extends NotificationDto>
  extends BaseDataTableComponent<T, NotificationColumnKey>
  implements OnInit
{
  override topMenu = signal<ActionMenu | null>(null);
  override columns = signal<DataListColumn<NotificationColumnKey>[]>([
    { key: 'context', label: 'Utilisateur', display: true },
    { key: 'title', label: 'Titre', display: true },
    { key: 'message', label: 'Message', display: true },
    { key: 'type', label: 'Type', display: true },
    { key: 'read', label: 'Statut', display: true },
    { key: 'createdAt', label: 'Date de création', display: true },
  ]);
  override topButtons = signal<ActionButton[]>([]);
  override itemActions = signal<ActionButton[]>([]);

  override filters = signal<DataHeaderFilter<NotificationAdminFilterKey>[]>([
    {
      label: 'Type',
      column: NotificationAdminFilterKey.Type,
    },
    {
      label: 'Lu',
      column: NotificationAdminFilterKey.Read,
    },
  ]);

  @ViewChild(MatSort) sort!: MatSort;

  ngOnInit(): void {
    this.route.queryParamMap.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((params) => {
      const type = params.getAll(NotificationAdminFilterKey.Type);
      const read = params.getAll(NotificationAdminFilterKey.Read);
      this.filterChanged({
        changed: true,
        filter: {
          type: type.length ? type : [],
          read: read.length ? read : [],
        },
      });
    });
  }

  abstract override getAll(): Observable<T[]>;
  abstract override countAll(): Observable<number>;
  override getDisplayForEntry(key: NotificationAdminFilterKey, rawValue: string): string {
    switch (key) {
      case NotificationAdminFilterKey.Type:
        return rawValue;
      case NotificationAdminFilterKey.Read:
        return rawValue === 'true' ? 'Lu' : 'Non lu';
      default:
        return key;
    }
  }
}
